module.exports = __webpack_public_path__ + "img/nurse.8cf2c2a9.svg";